
import { Loader } from '@loader/loader';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@NgModule({
    imports:
        [
            CommonModule,
            MatProgressSpinnerModule
        ],
    declarations: [Loader],
    exports: [Loader, MatProgressSpinnerModule]
})
export class LoaderModule { }
